import React from "react";
import DataTableBase from "./dataTableBase";
import { ApplicationColumns } from "./columnDefs";

export default function ApplicationsTable({ applications = [] }) {
  return (
    <DataTableBase
      title={"Applications"}
      data={applications}
      columns={ApplicationColumns}
      orderby="brand"
    />
  );
}
